import React from 'react';

interface AppFooterProps {
    layoutColorMode: string;
}

const AppFooter: React.FC<AppFooterProps> = ({ layoutColorMode }) => {
    return (
        <div className="layout-footer">
            <img src={`assets/layout/images/logo-${layoutColorMode}.svg`} alt="Logo" height="20" className="mr-2" />
            by
            <span className="font-medium ml-2">DevStack.One</span>
        </div>
    );
}

export default AppFooter;